export const capitalizeString = (string: string | string[]) => {
  if (string) {
    return Array.isArray(string)
      ? string.map((str) => str[0].toUpperCase() + str.substring(1))
      : string[0].toUpperCase() + string.substring(1);
  }
};
